<template>
    <div class="wrap-content">
        <div class="title">
            <router-link to="/">
                <img src="../assets/abi-vertical.png" alt="" class="img-title" />
            </router-link>
        </div>
        <div class="hello">
            <div class="content-left">
                <p>Belum Punya Akun?</p>
                <router-link class="login" to="/register"><button class="btn-scondary">Daftar</button> </router-link>
            </div>
            <div class="content-right">
                <p class="brand">Login</p>
                <form @submit.prevent="login">
                    <div class="form-group">
                        <label for="">Email/ No Telepon</label>
                        <input
                            type="text"
                            class="form-input"
                            placeholder="Masukkan email/no telepon"
                            v-model="$v.form.data_pribadi.$model"
                            name="data_pribadi"
                            @input="clearMeg"
                        />
                        <div class="error" v-if="$v.form.data_pribadi.$error">
                            Email tidak boleh kosong
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Password</label>
                        <input :type="type" class="form-input" placeholder="Password" v-model="$v.form.password.$model" @input="clearMeg" />
                        <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="showEye"></b-icon>
                        <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="showEye"></b-icon>
                        <div v-if="$v.form.password.$error">
                            <div class="error" v-if="!$v.form.password.required">
                                Password tidak boleh kosong
                            </div>
                            <div class="error" v-if="!$v.form.password.minLength">
                                Password minimal 8 karakter
                            </div>
                        </div>
                    </div>
                    <div class="error" v-show="status == 405">
                        Anda Belum Melakukan Demo Account. Silahkan Melakukan demo terlebih dahulu.
                        <a :href="'https://' + urlDemo" target="_blank">Klik Link Berikut !</a>
                    </div>
                    <div class="error" v-if="statusLogin">
                        <div v-if="msgLogin == 403">
                            <div class="error">Email belum aktif, silahkan aktivasi email anda</div>
                            <div class="btn-resend-email">Belum dapat link aktivasi? <span @click="openModal = true">Klik Disini</span></div>
                        </div>
                        <span v-else>{{ msgLogin }}</span>
                    </div>
                    <div class="error" v-if="status == 407">
                        Maaf akun anda sedang dalam proses pembuatan akun demo, akun demo akan dikirim melalui email yang sudah didaftarkan
                    </div>
                    <div class="footer-form">
                        <button class="btn-primer" type="submit">
                            <Loading class="loader" v-if="isLoading" />
                            <div v-else>Login</div>
                        </button>
                        <router-link to="/resetpassword" class="have-account">Lupa Password?</router-link>
                    </div>
                </form>
            </div>
        </div>
        <div class="self-modal" v-show="openModal">
            <div class="content-modal" ref="modal">
                <form @submit.prevent="resendEmail">
                    <div class="title-modal">
                        <span class="show-content">Kirim Ulang Verifikasi Email</span>
                        <button type="button" class="close" @click="openModal = false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="body-modal">
                        <input type="email" v-model="reEmail" class="form-input re-email" placeholder="Masukkan email anda" required />
                        <div class="error" v-show="statusCodeResendEmail == 202">Email sudah aktif</div>
                        <div class="error" v-show="statusCodeResendEmail == 1001">Email belum terdaftar</div>
                        <div class="succes" v-show="statusCodeResendEmail == 200">Link berhasil dikirim, cek email anda</div>
                    </div>
                    <div class="footer-modal">
                        <button type="submit" class="btn-scondary show-content">
                            <b-spinner small label="Small Spinner" v-show="isloadingReEmail"></b-spinner>
                            <div v-show="!isloadingReEmail">Kirim</div>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import Loading from "../assets/Loading";
import axios from "axios";
import sha256 from "sha256";

export default {
    components: {
        Loading,
    },
    data() {
        return {
            form: {
                data_pribadi: "",
                password: "",
            },
            selected: false,
            type: "password",
            role: localStorage.getItem("role"),
            isLoading: false,
            status: "",
            statusCodeResendEmail: "",
            isCimb: "",
            isBank: "",
            openModal: false,
            isloadingReEmail: false,
            reEmail: "",
            urlDemo: "",
            dataInput: [],
            msgLogin: "",
            scriptCaptcha: "",
        };
    },
    validations: {
        form: {
            data_pribadi: {
                required,
            },
            password: {
                required,
                minLength: minLength(8),
            },
        },
    },
    methods: {
        clearMeg() {
            this.status = "";
            this.msgLogin = "";
        },
        showEye() {
            if (this.type == "password") {
                this.type = "text";
                this.selected = !this.selected;
            } else {
                this.type = "password";
                this.selected = !this.selected;
            }
        },

        login() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isLoading = true;

            this.msgLogin = "";

            var phoneno = /^[0-9]*$/;
            var emailRegex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
            if (this.form.data_pribadi.match(phoneno)) {
                this.dataInput = {
                    phonenumber: this.form.data_pribadi,
                    password: sha256(this.form.password),
                };
            } else if (this.form.data_pribadi.match(emailRegex)) {
                this.dataInput = {
                    email: this.form.data_pribadi,
                    password: sha256(this.form.password),
                };
            } else {
                this.dataInput = {
                    username: this.form.data_pribadi,
                    password: sha256(this.form.password),
                };
            }

            window.grecaptcha.enterprise.ready(async () => {
                // const tokenCaptcha = await window.grecaptcha.enterprise.execute("6LeqJlIfAAAAAKiLEDw-dGkgLpyj695P4IoTuMa8", { action: "LOGINBROKERPBKABI" });
                const tokenCaptcha = await window.grecaptcha.enterprise.execute("6Lcpm-AkAAAAAKKack5w7MK_Hq5Ix3Zt5OztXSc8", { action: "LOGINBROKERPBKABI" });
                this.dataInput["clientCaptchaKey"] = tokenCaptcha;
                this.$store
                    .dispatch("LOGIN", this.dataInput)
                    .then((resLogin) => {
                        if (resLogin.data.data.status_code == "00" && resLogin.data.data.status == "kyc") {
                            this.$store.dispatch("getCustomer").then((res) => {
                                if (res) {
                                    if (res.opening_status == "open") {
                                        // console.log("kondisi belum buka akun dan sudah ngisi beberapa");
                                        if (res.step == "companyProfil") {
                                            window.location.href = "/profil-perusahaan";
                                        } else if (res.step == "simulation") {
                                            window.location.href = "/simulasi";
                                        } else if (res.step == "experienceTrading") {
                                            window.location.href = "investment-experience";
                                        } else if (res.step == "disclosurCustomer") {
                                            window.location.href = "/disclosure1";
                                        } else if (res.step == "customer") {
                                            window.location.href = "/register-datapribadi";
                                        } else if (res.step == "work") {
                                            window.location.href = "/register-datapekerjaan";
                                        } else if (res.step == "contact") {
                                            window.location.href = "/register-datakontak";
                                        } else if (res.step == "finance") {
                                            window.location.href = "/register-datakeuangan";
                                        } else if (res.step == "account") {
                                            window.location.href = "/register-datarekening";
                                        } else if (res.step == "attactment") {
                                            window.location.href = "/register-datalampiran";
                                        } else if (res.step == "risk") {
                                            window.location.href = "/resiko";
                                        } else if (res.step == "disclousureRisk") {
                                            window.location.href = "/disclosure2";
                                        } else if (res.step == "disclousureMandat") {
                                            window.location.href = "/disclosure3";
                                        } else if (res.step == "mandate") {
                                            window.location.href = "/amanat";
                                        } else if (res.step == "codeAccess") {
                                            window.location.href = "/kode-akses";
                                        } else if (res.step == "verification") {
                                            window.location.href = "/verification-page";
                                        } else {
                                            window.location.href = "/profil-perusahaan";
                                        }
                                    } else if (res && (res.opening_status == "waiting" || res.opening_status == "document-approved")) {
                                        window.location.href = "/register-waiting";
                                    } else if (res && res.status == 6) {
                                        window.location.href = "konfirmasi-pialang";
                                    } else if (res.opening_status == "wait-deposit" || res.opening_status == "send-acceptance" || res.opening_status == "approve") {
                                        window.location.href = "deposit";
                                    } else {
                                        window.location.href = "/profil-perusahaan";
                                    }
                                    localStorage.setItem("role", res.status);
                                } else {
                                    window.location.href = "/profil-perusahaan";
                                }
                                // this.isLoading = false;
                            });
                        } else if (resLogin.data.data.status_code == "00" && resLogin.data.data.status == "active") {
                            this.status = 407;
                            this.isLoading = false;
                        } else {
                            this.isLoading = false;
                            this.status = "";
                        }
                    })
                    .catch((error) => {
                        this.status = error.response.status;
                        this.isLoading = false;
                    });
            });
        },

        resendEmail() {
            this.isloadingReEmail = true;
            axios
                .post("/v2/user/register/resend/email", {
                    email: this.reEmail,
                })
                .then((res) => {
                    this.isloadingReEmail = false;
                    this.statusCodeResendEmail = res.data.status;
                    if (this.statusCodeResendEmail == 200) {
                        this.$notify({
                            group: "foo",
                            title: "<h5>Link aktivasi email berhasil dikirm</h5>",
                            type: "success",
                            duration: 2000,
                        });
                        setTimeout(function() {
                            this.openModal = !this.openModal;
                        }, 2000);
                    }
                })
                .catch((err) => {
                    this.statusCodeResendEmail = err.response.data.data.status_code;
                    this.isloadingReEmail = false;
                });
        },
    },
    computed: {
        loadingLogin() {
            return this.$store.getters.loginLoading;
        },
        statusLogin() {
            let status = this.$store.state.status_login;
            // let errMessage = this.$store.state.errMsgLogin;
            let like = this;
            if (status == 2006) {
                like.msgLogin = "Email atau Password salah";
            } else if (status == 2019) {
                like.msgLogin = "Email atau Password salah";
            } else if (status == 2003) {
                like.msgLogin = 403;
            } else if (status == 2001) {
                like.msgLogin = "Pastikan akun dan password anda benar";
            } else if (status == 2022) {
                like.msgLogin = "Email atau Password salah";
            } else if (status == 2023) {
                like.msgLogin = "Email atau Password salah";
            } else {
                like.msgLogin = "";
            }
            return like.msgLogin;
        },
    },
    created() {
        this.scriptCaptcha = document.createElement("script");

        // this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6LeqJlIfAAAAAKiLEDw-dGkgLpyj695P4IoTuMa8"; //dev
        this.scriptCaptcha.src = "https://www.google.com/recaptcha/enterprise.js?render=6Lcpm-AkAAAAAKKack5w7MK_Hq5Ix3Zt5OztXSc8"; //prod
        this.scriptCaptcha.async = true;

        document.body.appendChild(this.scriptCaptcha);
    },
    beforeDestroy() {
        document.body.removeChild(this.scriptCaptcha);
    },
    mounted() {
        if (this.form.data_pribadi == "" || this.form.password == "") {
            this.msgLogin = "";
        }
    },
};
</script>

<style scoped>
.wrap-content {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(197, 151, 51, 0.4);
    flex-direction: column;
}

.title {
    text-align: center;
}

.img-title {
    height: 98px;
    margin-bottom: 40px;
}

.hello {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content-left {
    width: 200px;
    background: #1e354a;
    height: 405px;
    color: white;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px 0 0 10px;
}

.content-left p {
    font-size: 20px;
    margin-bottom: 40px;
}

.content-modal {
    width: 35rem;
}

.body-modal {
    padding: 25px 20px;
}

.footer-modal {
    margin: 15px 0px 0 15px;
}

.content-right {
    width: 40%;
    min-height: 29rem;
    background: white;
    padding: 30px 50px;
    border-radius: 5px;
    border: 1px solid #ddd;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.form-input {
    width: 100%;
    font-size: 12px;
    border-radius: 0;
    height: 37px;
    border: none;
    border-bottom: 1px solid #9a9a9a;
    padding: 0px;
    box-shadow: none;
    background: #fff;
}

label {
    font-size: 13px;
    display: inline-block;
    margin-bottom: 0px;
}

.error {
    padding: 0;
}

.btn-resend-email {
    font-size: 13px;
    color: #707070;
}

.btn-resend-email span {
    color: #c59733;
    cursor: pointer;
}
.btn-resend-email span:hover {
    color: #997528;
    text-decoration: underline;
}

.brand {
    font-size: 25px;
    font-weight: bold;
    margin: 0 0 50px;
    position: relative;
}

.brand::after {
    content: "";
    width: 47px;
    height: 3px;
    background: #c59733;
    position: absolute;
    bottom: -3px;
    left: 2px;
}

.footer-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    top: 25px;
}

.btn-primer {
    margin: 15px 0 0;
}

.btn-scondary {
    background: transparent;
    font-size: 13px;
    width: 125px;
    height: 39px;
    border: solid 1px var(--scondary);
}

.have-account {
    font-size: 14px;
    margin: 10px;
    text-decoration: underline;
    color: #707070;
}

.form-group {
    position: relative;
    margin: 0 0 35px;
}

.form-input:focus {
    box-shadow: none;
    border-color: #c59733;
}

.icon-eye {
    position: absolute;
    font-size: 30px;
    right: 15px;
    top: 25px;
}

.register {
    font-size: 14px;
    margin-left: 30px;
}

.register-button {
    font-weight: bold;
    color: #1f354a;
    cursor: pointer;
}

.register-button:hover {
    text-decoration: underline;
}

@media (max-width: 720px) {
    .wrap-content {
        display: block;
        padding: 20px;
    }
    .title {
        text-align: left;
    }

    .img-title {
        height: 40px;
    }

    .hello {
        flex-direction: column-reverse;
        gap: 3rem;
    }

    .content-right {
        width: 100%;
        padding: 30px;
    }

    .content-left {
        width: 100%;
        height: 20px;
        background: transparent;
        flex-direction: row;
        align-items: center;
        color: #707070;
        font-size: 13px;
    }

    .content-left p {
        margin-bottom: 0;
        font-size: 12px;
    }

    .btn-scondary {
        background: var(--primary);
        border: none;
        color: #fff;
        width: 70px;
        height: 30px;
        margin-left: 15px;
    }

    .btn-primer {
        width: 100%;
    }

    .content-modal {
        width: 90%;
    }

    .footer-form {
        flex-direction: column;
        gap: 1rem;
    }

    .footer-modal div {
        line-height: 2;
    }
    .have-account {
        text-align: center;
    }

    .icon-eye {
        right: 20px;
    }
}
</style>
